export default "__VITE_ASSET__Cr67HBqC__"